export default __webpack_public_path__ + "images/UU.36d32ad.png";